import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';
import { resolveFollowupTask, type ResolveFollowupPayload } from '../api/tasks';

export function useResolveFollowupTask(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ taskId, payload }: { taskId: string; payload: ResolveFollowupPayload }) =>
      resolveFollowupTask(taskId, payload),
    onSuccess: async () => {
      notification.success({ message: 'Follow-up completed successfully' });
      await queryClient.invalidateQueries({ queryKey: ['taskItems'] });
      await queryClient.invalidateQueries({ queryKey: ['taskItem'] });
      await queryClient.invalidateQueries({ queryKey: ['lead'] });
      await queryClient.invalidateQueries({ queryKey: ['contactKundali'] });
      await queryClient.invalidateQueries({ queryKey: ['task-dashboard'] });
      onSuccess?.();
    },
    onError: () => {
      notification.error({ message: 'Failed to complete follow-up' });
    },
  });
}
